import { useEffect, useState } from 'react';
import { useAppDispatch } from 'redux/hooks/reduxHooks';
import { setCameraPermission, setMicrophonePermission } from 'redux/slices/modals/modals.slice';
import { EPermissionDeviceTypes } from 'shared/types/permission.interface';

export const useCurrentDevicePermissions = (name: string) => {
  const [permission, setPermission] = useState(null);
  const dispatch = useAppDispatch();

  useEffect(() => {
    let mounted = true;
    navigator.permissions.query({ name: name as PermissionName }).then((res) => {
      if (!mounted) return;

      setPermission(res);
      if (name === EPermissionDeviceTypes.Camera) {
        dispatch(setCameraPermission(res.state));
      } else if (name === EPermissionDeviceTypes.Microphone) {
        dispatch(setMicrophonePermission(res.state));
      }
    });

    return () => {
      mounted = false;
    };
  }, [dispatch, name]);

  useEffect(() => {
    if (!permission) return;

    const handleChange = (e: any) => {
      if (name === EPermissionDeviceTypes.Camera) {
        dispatch(setCameraPermission(e.target.state));
      } else if (name === EPermissionDeviceTypes.Microphone) {
        dispatch(setMicrophonePermission(e.target.state));
      }
    };

    permission.addEventListener('change', handleChange);

    return () => {
      permission.removeEventListener('change', handleChange);
    };
  }, [dispatch, name, permission]);
};
